import { AwardingClient } from "@/utils/EvoClient";
import { CompleteCallForCompetitionDto } from "../dto";
import { AxiosResponse } from "axios";

const ENDPOINT = "c/complete-call-for-competition";

export default async function completeCallForCompetition(
  dto: CompleteCallForCompetitionDto
): Promise<string> {
  return ((await AwardingClient.post(ENDPOINT, dto)) as AxiosResponse).data.id;
}
